// DOM-free canvas factory shared by the 1x and 2x painters. The 2x painters also run in a Web Worker (hd-worker.ts),
// where there is no `document`: there it makes OffscreenCanvas. On the main thread it makes a normal <canvas>, since Pixi
// textures, the HUD and the editors use real elements. Both are typed as HTMLCanvasElement / CanvasRenderingContext2D:
// the painters only use width, height, getContext and drawImage, which the two kinds share.
export type Cv = HTMLCanvasElement;

/** a bare canvas, context settings untouched (painters that set up their own context) */
export function rawCanvas(w: number, h: number): HTMLCanvasElement {
  const c: HTMLCanvasElement = typeof document !== 'undefined' ? document.createElement('canvas') : new OffscreenCanvas(w, h) as unknown as HTMLCanvasElement;
  c.width = w; c.height = h; return c;
}
export function canvas(w: number, h: number): [HTMLCanvasElement, CanvasRenderingContext2D] {
  const c = rawCanvas(w, h), g = c.getContext('2d')!; g.imageSmoothingEnabled = false; return [c, g];
}
